/**
 * Physical Therapy Missed Visit Report — options + empty payload.
 * After shared common header: Reason → Attempts → Impact on POC (per screenshot).
 * No wound section. Pattern matches PT Visit Note.
 */

import { emptyPtNotesCommonHeader } from "./ptNotesCommonHeaderUtils";

export const MISSED_REASON_OPTIONS = [
  "Patient/Caregiver not available (No answer)",
  "Patient/Caregiver cancelled / Rescheduled",
  "Patient refused visit",
  "Patient not feeling well / Ill",
  "Patient hospitalized",
  "Patient out of town",
  "Inclement weather",
  "No safe access / Environmental barrier",
  "No caregiver present",
  "Patient at MD appointment",
];

export const ATTEMPT_COUNT_OPTIONS = ["1", "2", "3", "4+"];

export const CONTACT_METHOD_OPTIONS = [
  "Phone Call",
  "Text Message",
  "Voicemail",
];

export const INTERVENTION_AFFECTED_OPTIONS = [
  "Strengthening",
  "Balance Training",
  "Pain Management",
  "Education",
  "Gait / Mobility Training",
  "Transfer Training",
  "ROM / Flexibility",
  "Other",
];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

/** Full editable PT Missed Visit payload (JSON on dedicated row). */
export const emptyPtMissedVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  missedVisitDate: "",
  commonHeader: emptyPtNotesCommonHeader(),

  // —— 7. Reason for Missed Visit ——
  missedReasons: [],
  reasonOtherSpecify: "",

  // —— 8. Attempts Made ——
  attemptsCount: "",
  contactMethods: [],

  // —— 9. Impact on Plan of Care ——
  awareOfNextVisit: "",
  interventionsAffected: [],
  interventionOther: "",
  planToAddress: "",
});

export const PT_MISSED_ARRAY_KEYS = [
  "missedReasons",
  "contactMethods",
  "interventionsAffected",
];
